import { useContext } from "react";
import DataRow from "./DataRow";

import TrainloadContext from "../Store/trainload-context";
// import Skeleton from "./Skeleton";

const Content = () => {


    const trainloadCtx = useContext(TrainloadContext);


    // const handleClick = async () => {
    //     console.log("Clicked");
    //     // fetch('https://jsonplaceholder.typicode.com/todos/1')
    //     //     .then(response => response.json())
    //     //     .then(json => console.log(json))
    //     let response = await fetch('https://jsonplaceholder.typicode.com/todos/1');
    //     let result = await response.json()
    //     console.log(result.title);
    //     setTitle(result.title);
    // }

    // const sortByKeyName = (originalObject, isReverseOrder = false) => {
    //     const entries = Object.entries(originalObject);
    //     if(isReverseOrder){ // ture
    //         entries.sort((a, b) => b[0].localeCompare(a[0])); // Sorting in reverse order
    //     } else{
    //         entries.sort((a, b) => a[0].localeCompare(b[0]));
    //     }
    //     const sortedObject = Object.fromEntries(entries);

    //     return sortedObject;
    // }

    // const sortByTD = (originalObject, isReverseOrder = false) => {
    //     const entries = Object.entries(originalObject);


    //     const x = (a, b) => {
    //         let x = a.toLowerCase();
    //         let y = b.toLowerCase();
    //         if (x < y) { return -1; }
    //         if (x > y) { return 1; }
    //         return 0;
    //     }

    //     if(isReverseOrder){ // ture
    //         entries.sort((a, b) => x(b[1].td, a[1].td)); // Sorting by the 'td' property
    //     }else{
    //         entries.sort((a, b) => {   
    //             // return a[1].td.localeCompare(b[1].td)
    //             return x(a[1].td, b[1].td);
    //         }); // Sorting by the 'td' property
    //     }

        
    //     const sortedObject = Object.fromEntries(entries);

    //     return sortedObject;
    // }


    // const sortByLastUpdate = (originalObject, isReverseOrder = false) => {
    //     const entries = Object.entries(originalObject);

    //     if(isReverseOrder){ // ture
    //         entries.sort((a, b) => a[1].updatedTime - b[1].updatedTime); // Sorting by the 'updatedTime' property
    //         // entries.sort((a, b) => a[1].lambdaDateTime - b[1].lambdaDateTime); // Sorting by the 'lambdaDateTime' property
    //         // entries.sort((a, b) => a[1].ttl - b[1].ttl); // Sorting by the 'ttl' property            
    //     } else {
    //         entries.sort((a, b) => b[1].updatedTime - a[1].updatedTime); // Sorting by the 'updatedTime' property
    //         // entries.sort((a, b) => b[1].lambdaDateTime - a[1].lambdaDateTime); // Sorting by the 'lambdaDateTime' property
    //         // entries.sort((a, b) => b[1].ttl - a[1].ttl); // Sorting by the 'ttl' property
    //     }




    //     const sortedObject = Object.fromEntries(entries);

    //     return sortedObject;
    // }







    const Display = (result) => {

        // console.log("trainloadCtx.trainloaddata", trainloadCtx.trainloaddata);

        // return result.map((data) => {
        //     return (
        //         // <DataRow userId={data.userId} id={data.id} title={data.title} completed={data.completed} ></DataRow>
        //         <div key={data.trainId} className="data-row" id={data.trainId}>

        //             <DataRow data={data}></DataRow>
        //         </div>

        //     )
        // })


        // console.log(sortByLastUpdate(result));



        const entries = Object.entries(result); // convert into array

        console.log("asdfg");
        console.log(entries);

        // const entries_without_m_train = entries.filter(item => item[1].trainType !== "M-train"); 

        // for (const key of Object.keys(funnel)) {
        //     funnel[key](entries);
        // }
        // console.log(entries);

        console.log("Now Funnel: ", trainloadCtx.funnel);

        // const finalSortedArray = Object.values(trainloadCtx.funnel).reduce((acc, fn) => fn(acc), entries_without_m_train);
        const finalSortedArray = Object.values(trainloadCtx.funnel).reduce((acc, fn) => fn(acc), entries);

        // console.log(finalSortedArray);

        const sortedObject = Object.fromEntries(finalSortedArray); //convert into object








        return (
            <>
                {/* {Object.keys(result).map(key => ( */}
                {Object.keys(sortedObject).map(key => (
                    // <div key={key}>
                    //     <p>ID: {yourObject[key].id}</p>
                    //     <p>Name: {yourObject[key].name}</p>
                    // </div>
                    <div key={key} className="data-row" id={key}>

                        <DataRow data={result[key]}></DataRow>
                    </div>
                ))}
            </>
        )
    };

    return (
        <>

            {/* {Display(props.trainloaddata)} */}
            {Display(trainloadCtx.trainloaddata)}
        </>
    );
}

export default Content;